<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue';
import { $api } from '@/services';
import { useStore } from 'vuex';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import ConfirmUpload from '@/views/lucahub/ConfirmUpload.vue';

const store = useStore();
const operating_license = ref([]);
const management_certifications = ref([]);
const other_documents = ref([]);
const dob = ref(null);
const type = ref(null);
const props = defineProps(['id', 'day', 'open']);
const emit = defineEmits(['close', 'update']);
const operating_license_assets_keys = ref([]);
const management_certifications_assets_keys = ref([]);
const other_documents_assets_keys = ref([]);
const openModal = ref(false);

const getDocument = async () => {
	try {
		const res = await $api.org.getDocument(props.id);
		if (res.data) {
			operating_license.value = res.data.operating_license || [];
			management_certifications.value =
				res.data.management_certifications || [];
			other_documents.value = res.data.other_documents || [];
		}
	} catch (e) {
		console.log(e);
	}
};

watch(
	() => props.open,
	() => {
		dob.value = props.day;
		getDocument();
	},
	{ immediate: true, deep: true }
);

const openModelUpload = (data) => {
	type.value = data;
	const target = document.getElementById('upload-images-lucahub');
	target ? target.click() : '';
};
const closeUpload = () => {
	const target = document.getElementById('upload-images-lucahub');
	target ? (target.value = null) : '';
};
const isImage = (icon) => {
	const ext = ['.jpg', '.jpeg', '.png', '.svg'];
	return ext.some((el) => icon.toLowerCase().endsWith(el));
};
const uploadLucahub = (event) => {
	let fileUploads = Array.from(event?.target?.files || []);
	if (!fileUploads || !fileUploads.length) {
		return;
	}
	fileUploads.forEach((file) => {
		switch (type.value) {
			case 'operating_license':
				operating_license.value.push(file);
				console.log(operating_license.value, 'operating_license.value');
				break;
			case 'management_certifications':
				management_certifications.value.push(file);
				break;
			case 'other_documents':
				other_documents.value.push(file);
				break;
		}
	});

	closeUpload();
};
const getUrl = (file) => {
	if (!file || file?.asset_url || file?.url) {
		return file?.asset_url || file?.url || '';
	}
	return URL.createObjectURL(file);
};
const removeImage = (index, type, fileType) => {
	switch (type) {
		case 'operating_license': {
			if (fileType === 'pdf') {
				const filtered = operating_license.value.filter(
					(i) => i.type === 'application/pdf'
				);
				const item = filtered[index];
				operating_license.value = operating_license.value.filter(
					(i) => i !== item
				);
			} else {
				const filtered = operating_license.value.filter(
					(i) => i.type !== 'application/pdf'
				);
				const item = filtered[index];
				operating_license.value = operating_license.value.filter(
					(i) => i !== item
				);
			}
			break;
		}
		case 'management_certifications': {
			if (fileType === 'pdf') {
				const filtered = management_certifications.value.filter(
					(i) => i.type === 'application/pdf'
				);
				const item = filtered[index];
				management_certifications.value =
					management_certifications.value.filter((i) => i !== item);
			} else {
				const filtered = management_certifications.value.filter(
					(i) => i.type !== 'application/pdf'
				);
				const item = filtered[index];
				management_certifications.value =
					management_certifications.value.filter((i) => i !== item);
			}
			break;
		}
		case 'other_documents': {
			if (fileType === 'pdf') {
				const filtered = other_documents.value.filter(
					(i) => i.type === 'application/pdf'
				);
				const item = filtered[index];
				other_documents.value = other_documents.value.filter(
					(i) => i !== item
				);
			} else {
				const filtered = other_documents.value.filter(
					(i) => i.type !== 'application/pdf'
				);
				const item = filtered[index];
				other_documents.value = other_documents.value.filter(
					(i) => i !== item
				);
			}
			break;
		}
	}
};
const getSignatures = async (listImage) => {
	const fileList = listImage;
	const {
		data: { data },
	} = await $api.file.getSignatures({
		mime_types: fileList.map((f) => f.type),
		prefix: 'lucahub',
	});
	if (data && data.length) {
		for (let i = 0; i < data.length; i++) {
			let formData = new FormData();
			formData.append('AWSAccessKeyId', data[0]['AWSAccessKeyId'] || '');
			formData.append('key', data[i].key || '');
			formData.append('acl', data[i].acl || '');
			formData.append('Content-Type', data[i]['Content-Type'] || '');
			formData.append('x-amz-signature', data[i].signature || '');
			formData.append('Signature', data[i].signature || '');
			formData.append('Policy', data[i].policy || '');
			formData.append(
				'success_action_status',
				data[i].success_action_status || ''
			);
			formData.append('file', fileList[i]);
			await uploadToS3(data[i].action, formData, fileList[i]);
		}
	}
};

const uploadToS3 = async (url, payload, file) => {
	try {
		console.log(file);
		const { data } = await $api.file.uploadToS3(url, payload);
		const keyData = data.toString().match('<Key>(.*)</Key>');
		console.log('data', {
			key: keyData && keyData.length ? keyData[1] : '',
			type: file.type,
		});
		switch (type.value) {
			case 'operating_license':
				operating_license_assets_keys.value.push({
					key: keyData && keyData.length ? keyData[1] : '',
					type: file.type,
					name: file.name,
				});
				console.log(
					operating_license_assets_keys.value,
					'operating_license_assets_keys.value'
				);
				break;
			case 'management_certifications':
				management_certifications_assets_keys.value.push({
					key: keyData && keyData.length ? keyData[1] : '',
					type: file.type,
					name: file.name,
				});
				break;
			case 'other_documents':
				other_documents_assets_keys.value.push({
					key: keyData && keyData.length ? keyData[1] : '',
					type: file.type,
					name: file.name,
				});
				break;
		}
	} catch (e) {
		store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const submit = async () => {
	try {
		operating_license_assets_keys.value = operating_license.value
			.filter((f) => f?.asset_key)
			.map((f) => ({
				key: f.asset_key,
				type: f.type,
				name: f.name,
			}));
		management_certifications_assets_keys.value =
			management_certifications.value
				.filter((f) => f?.asset_key)
				.map((f) => ({
					key: f.asset_key,
					type: f.type,
					name: f.name,
				}));
		other_documents_assets_keys.value = other_documents.value
			.filter((f) => f?.asset_key)
			.map((f) => ({
				key: f.asset_key,
				type: f.type,
				name: f.name,
			}));
		if (operating_license.value.filter((i) => !i.asset_key).length > 0) {
			type.value = 'operating_license';
			await getSignatures(
				operating_license.value.filter((i) => !i.asset_key)
			);
		}
		if (
			management_certifications.value.filter((i) => !i.asset_key).length >
			0
		) {
			type.value = 'management_certifications';
			await getSignatures(
				management_certifications.value.filter((i) => !i.asset_key)
			);
		}
		if (other_documents.value.filter((i) => !i.asset_key).length > 0) {
			type.value = 'other_documents';
			await getSignatures(
				other_documents.value.filter((i) => !i.asset_key)
			);
		}
		const payload = {
			established_date: dob.value,
			operating_license_assets_keys: operating_license_assets_keys.value,
			management_certifications_assets_keys:
				management_certifications_assets_keys.value,
			other_documents_assets_keys: other_documents_assets_keys.value,
		};
		await $api.org.updateDocument(props.id, payload);
		emit('update');
	} catch (e) {
		console.log(e);
	}
};
</script>
<template>
	<!-- <ViewPhoto
		v-if="imageShow && photos.length"
		:key="photosIndex"
		:images="photos"
		:index="photosIndex"
		@close="imageShow = false"
		:name="goal?.name"
	/> -->
	<DaModalFrame v-model:open="openModal">
		<ConfirmUpload @close="openModal = false" @submit="submit" />
	</DaModalFrame>
	<input
		type="file"
		hidden
		id="upload-images-lucahub"
		@change="uploadLucahub"
		multiple
		accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg, image/jpg"
	/>
	<div class="fixed inset-y-0 right-0 w-sideover z-50 bg-white">
		<div class="p-6 bg-blue-50">
			<div class="flex items-start justify-between">
				<div class="flex items-center">
					<img
						class="w-6 h-6"
						src="@/assets/images/icons/pen.png"
						alt=""
					/>
					<div class="font-bold text-neutral-700 ml-1.5 text-2xl">
						Cập nhật thông tin
					</div>
				</div>
				<div class="ml-3 h-7 flex items-center">
					<button
						type="button"
						class="rounded-md text-neutral-400 hover:text-neutral-700"
						@click="$emit('close')"
					>
						<span class="sr-only">Close panel</span>
						<svg
							class="h-6 w-6"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
		<div class="w-full flex flex-col shadow-xl sideover-content">
			<div
				v-if="!isLoading"
				class="__goal-management-student-detail p-10 md-down:px-4"
			>
				<div class="w-full mb-6">
					<div class="font-semibold text-neutral-600 mb-2">
						Ngày thành lập
					</div>
					<div class="select-tabs">
						<div class="input-group w-full">
							<VueDatepicker
								v-model="dob"
								:maxDate="new Date()"
								autoApply
								class="input-date w-full"
								format="dd/MM/yyyy"
								placeholder="Chọn ngày thành lập"
								uid="filter-by-date"
							>
								<template #input-icon>
									<svg
										fill="none"
										height="20"
										viewBox="0 0 20 20"
										width="20"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
											fill="#94A3B8"
											fill-rule="evenodd"
										/>
									</svg>
								</template>
							</VueDatepicker>
						</div>
					</div>
				</div>
				<div class="w-full mb-6">
					<div class="flex items-center justify-between mb-2">
						<div class="font-semibold text-neutral-600">
							Giấy phép hoạt động còn hiệu lực
						</div>
						<div
							class="text-yellow-700 font-semibold text-sm cursor-pointer"
							@click="openModelUpload('operating_license')"
							v-if="operating_license?.length"
						>
							Thêm hồ sơ
						</div>
					</div>
					<div class="w-full flex gap-8">
						<div v-if="operating_license?.length">
							<div class="grid grid-cols-4 gap-4">
								<div
									v-for="(
										image, index
									) in operating_license.filter(
										(i) => i.type !== 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="absolute top-2 right-2 cursor-pointer"
										@click="
											removeImage(
												index,
												'operating_license'
											)
										"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g opacity="0.5">
												<rect
													width="12"
													height="12"
													rx="6"
													fill="black"
												/>
											</g>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="white"
											/>
										</svg>
									</div>
									<img
										:src="getUrl(image)"
										alt=""
										class="rounded-lg object-fill h-full w-full"
										style="aspect-ratio: 4/3"
										@click="openMediaPopup(index)"
									/>
								</div>
							</div>
							<div class="flex flex-col gap-1 mt-2">
								<div
									v-for="(
										file, index
									) in operating_license.filter(
										(i) => i.type === 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="text-neutral-400 flex items-center gap-2"
									>
										<svg
											width="24"
											height="32"
											viewBox="0 0 24 32"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
												fill="#E5A42B"
											/>
										</svg>
										<a
											:href="file?.url"
											target="_blank"
											class="hover:underline cursor-pointer"
										>
											{{ file.name }}</a
										>
										<svg
											@click.stop="
												removeImage(
													index,
													'operating_license',
													'pdf'
												)
											"
											class="text-gray-400 cursor-pointer"
											width="20"
											height="20"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="w-full text-neutral-500 bg-white flex flex-col items-center justify-senter text-center gap-2 rounded-lg p-8 cursor-pointer border-2 border-dashed hover:border-yellow-500"
							@click="openModelUpload('operating_license')"
						>
							<img
								src="@/assets/images/icons/cloud-upload-fill.png"
								alt=""
							/>
							<div class="font-semibold">
								Tải lên giấy phép hoạt động còn hiệu lực của cơ
								sở
							</div>
							<div class="text-sm">PNG, JPG & PDF</div>
						</div>
					</div>
				</div>
				<div class="w-full mb-6">
					<div class="flex items-center justify-between mb-2">
						<div class="font-semibold text-neutral-600">
							Bằng cấp, chứng chỉ của cấp Quản lý
						</div>
						<div
							class="text-yellow-700 font-semibold text-sm cursor-pointer"
							@click="
								openModelUpload('management_certifications')
							"
							v-if="management_certifications?.length"
						>
							Thêm hồ sơ
						</div>
					</div>
					<div class="w-full flex gap-8">
						<div v-if="management_certifications?.length">
							<div class="grid grid-cols-4 gap-4">
								<div
									v-for="(
										image, index
									) in management_certifications.filter(
										(i) => i.type !== 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="absolute top-2 right-2 cursor-pointer"
										@click="
											removeImage(
												index,
												'management_certifications'
											)
										"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g opacity="0.5">
												<rect
													width="12"
													height="12"
													rx="6"
													fill="black"
												/>
											</g>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="white"
											/>
										</svg>
									</div>
									<img
										:src="getUrl(image)"
										alt=""
										class="rounded-lg object-fill h-full w-full"
										style="aspect-ratio: 4/3"
										@click="openMediaPopup(index)"
									/>
								</div>
							</div>
							<div class="flex flex-col gap-1 mt-2">
								<div
									v-for="(
										file, index
									) in management_certifications.filter(
										(i) => i.type === 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="text-neutral-400 flex items-center gap-2"
									>
										<svg
											width="24"
											height="32"
											viewBox="0 0 24 32"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
												fill="#E5A42B"
											/>
										</svg>
										<a
											:href="file?.url"
											target="_blank"
											class="hover:underline cursor-pointer"
										>
											{{ file.name }}</a
										>
										<svg
											@click.stop="
												removeImage(
													index,
													'management_certifications',
													'pdf'
												)
											"
											class="text-gray-400 cursor-pointer"
											width="20"
											height="20"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="w-full text-neutral-500 bg-white flex flex-col items-center justify-senter text-center gap-2 rounded-lg p-8 cursor-pointer border-2 border-dashed hover:border-yellow-500"
							@click="
								openModelUpload('management_certifications')
							"
						>
							<img
								src="@/assets/images/icons/cloud-upload-fill.png"
								alt=""
							/>
							<div class="font-semibold">
								Tải lên bằng cấp, chứng chỉ của cấp Quản lý
							</div>
							<div class="text-sm">PNG, JPG & PDF</div>
						</div>
					</div>
				</div>
				<div class="w-full">
					<div class="flex items-center justify-between mb-2">
						<div class="font-semibold text-neutral-600">
							Hồ sơ khác
						</div>
						<div
							class="text-yellow-700 font-semibold text-sm cursor-pointer"
							@click="openModelUpload('other_documents')"
							v-if="other_documents?.length"
						>
							Thêm hồ sơ
						</div>
					</div>
					<div class="w-full flex gap-8">
						<div v-if="other_documents?.length">
							<div class="grid grid-cols-4 gap-4">
								<div
									v-for="(
										image, index
									) in other_documents.filter(
										(i) => i.type !== 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="absolute top-2 right-2 cursor-pointer"
										@click="
											removeImage(
												index,
												'other_documents'
											)
										"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g opacity="0.5">
												<rect
													width="12"
													height="12"
													rx="6"
													fill="black"
												/>
											</g>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="white"
											/>
										</svg>
									</div>
									<img
										:src="getUrl(image)"
										alt=""
										class="rounded-lg object-fill h-full w-full"
										style="aspect-ratio: 4/3"
										@click="openMediaPopup(index)"
									/>
								</div>
							</div>
							<div class="flex flex-col gap-1 mt-2">
								<div
									v-for="(
										file, index
									) in other_documents.filter(
										(i) => i.type === 'application/pdf'
									)"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="text-neutral-400 flex items-center gap-2"
									>
										<svg
											width="24"
											height="32"
											viewBox="0 0 24 32"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
												fill="#E5A42B"
											/>
										</svg>
										<a
											:href="file?.url"
											target="_blank"
											class="hover:underline cursor-pointer"
										>
											{{ file.name }}</a
										>
										<svg
											@click.stop="
												removeImage(
													index,
													'other_documents',
													'pdf'
												)
											"
											class="text-gray-400 cursor-pointer"
											width="20"
											height="20"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="w-full text-neutral-500 bg-white flex flex-col items-center justify-senter text-center gap-2 rounded-lg p-8 cursor-pointer border-2 border-dashed hover:border-yellow-500"
							@click="openModelUpload('other_documents')"
						>
							<img
								src="@/assets/images/icons/cloud-upload-fill.png"
								alt=""
							/>
							<div class="font-semibold">Tải lên hồ sơ khác</div>
							<div class="text-sm">PNG, JPG & PDF</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
		<div class="px-6 py-4 border-t border-yellow-50 bg-white">
			<div class="flex justify-end">
				<button
					class="button-p text-center whitespace-nowrap w-fit"
					type="button"
					@click="openModal = true"
				>
					Xác nhận
				</button>
			</div>
		</div>
	</div>
</template>

<script setup></script>
<style scoped>
.w-sideover {
	width: 720px;
}
.sideover-content {
	height: calc(100vh - 153px);
	overflow-y: auto;
}
@media only screen and (max-width: 768px) {
	.w-sideover {
		width: 100%;
	}
}
</style>
